import { getStringValue, getDefaultValue } from 'common/util/dataTypeValues';
import DateTime from 'common/components/DateTime/DateTime';

export const DataType = props => {
    const { dataType, value, subType, subTypeValues, className } = props;
    let finalValue = value,
        finalType = subType || dataType;
    if (subTypeValues && subTypeValues.indexOf(finalValue) === -1) {
        finalType = 'small_text';
        finalValue = 'not defined';
    }
    const rawValue = DataType.getRawValue(finalType, finalValue);
    return <span className={className} data-cy="DataType-return">{ isDateType(finalType) ? renderDateTime(rawValue, finalType) : rawValue }</span>;
};

function isDateType(type) {
    const comparableType = type.toLowerCase();
    return comparableType === 'datetime' || comparableType === 'dateonly';
}

function renderDateTime( value, type ) {
    const isDateTime = type.toLowerCase() === 'datetime';
    return <DateTime value={value} time={isDateTime} data-cy="DataType-DateTime"/>;
}

DataType.getRawValue = getStringValue;

DataType.getDefaultValue = getDefaultValue;

export default DataType;
